export const STATE_RESET = 'state/reset';

export interface StateReducerAction {
  type: typeof STATE_RESET;
}
